import React from 'react';
import {
  DialogActions,
  Typography,
  DialogTitle,
  IconButton,
  Button,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import route from '@src/constants/route';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import diamondImg from '@src/assets/images/diamond.png';
import { StyledLimitedFeaturesDialog } from './index.style';

const LimitedFeaturesDialog = ({
  title = 'limitedFeature',
  description,
  open,
  width,
  img = diamondImg,
  classNameImg = 'img',
  maxWidth = 'xs',
  onUpgrade,
  onClose,
  showButtonUnderstand = false,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleUpgradeNow = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      history.push(route.PAYMENT);
      dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
    }
  };
  return (
    <StyledLimitedFeaturesDialog
      open={open}
      width={width}
      maxWidth={maxWidth}
      fullWidth
      onClose={handleClose}
    >
      <DialogTitle classes={{ root: 'dialog-title' }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          color="secondary"
          className="close-button"
        >
          <CloseRoundedIcon color="secondary" />
        </IconButton>
      </DialogTitle>
      <div className="dialog-wrapper">
        <div className="img-wrapper">
          <img src={img} alt="icon" className={classNameImg} />
        </div>
        <Typography className="title">{t(title)}</Typography>
        <Typography
          className="description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        <DialogActions classes={{ root: 'dialog-action' }}>
          {showButtonUnderstand && (
            <Button className="button outlined-button" onClick={handleClose}>
              {t('gotItV2')}
            </Button>
          )}
          <Button
            className="button"
            variant="contained"
            onClick={handleUpgradeNow}
          >
            {t('upgradeNow')}
          </Button>
        </DialogActions>
      </div>
    </StyledLimitedFeaturesDialog>
  );
};

export default LimitedFeaturesDialog;
